const state = {
  breadcrumbs: []
}

const getters = {
  breadcrumbs(state, getters) {        
    state.breadcrumbs.length = 0
    state.breadcrumbs.push({
      name: 'mainpage',
      itemName: '',
      to: { name: 'equipmenttypes' }
    })
    if (getters.equipmentType.Code) {
      state.breadcrumbs.push({
        name: 'type',
        itemName: getters.equipmentType.Name,
        to: {
          name: 'equipmentmodelsbytype',
          params: { equipmentTypeId: getters.equipmentType.Code }
        }
      })
    }
    if (getters.equipmentModel.Code) {
      state.breadcrumbs.push({
        name: 'model',
        itemName: getters.equipmentModel.Name,
        to: {
          name: 'equipmentbymodel',
          params: { equipmentTypeId: getters.equipmentType.Code, equipmentModelId: getters.equipmentModel.Code }
        }
      })
    }
    if (getters.equipment.EquipmentId) {
      state.breadcrumbs.push({
        name: 'equipment',
        itemName: getters.equipment.Name,
        to: {
          name: 'inspections',
          params: { equipmentTypeId: getters.equipmentType.Code, equipmentModelId: getters.equipmentModel.Code, equipmentId: getters.equipment.EquipmentId }
        }
      })
    }
    // if (rootState.equipmentNode.Code) {
    //     state.breadcrumbs.push({
    //         name: 'node',
    //         itemName: rootState.equipmentNode.Name,
    //     });
    // }
    return state.breadcrumbs
  }
}

const actions = {}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}